import React, {useEffect, useState} from 'react';
import {SectionsProps, BusinessLevels} from "models";
import {Formik} from "formik";
import {Button} from "../../../../../components";
import LYNK_ICON from "assets/icons/lynk_icon.svg";
import LYNK_QR_IMAGE from "assets/payment/lynk_qrcode_image.jpg";

export const Payment: React.FC<SectionsProps> = ({
                                                     changeStep,
                                                     submitForm,
                                                     setNewBusinessInfo,
                                                     newBusinessInfo,
                                                     setSectionName
                                                 }) => {

    const [memberShipLevel, setMembershipLevel] = useState<Array<{ isActive: boolean, level: BusinessLevels, employees: string, price: string, description: string }>>([
        {
            isActive: false,
            level: BusinessLevels.MICRO_BUSINESS,
            employees: "1-5",
            price: "$3,000.000",
            description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
        },
        {
            isActive: false,
            level: BusinessLevels.SMALL_BUSINESS,
            employees: "6-20",
            price: "$10,000.00",
            description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
        },
        {
            isActive: false,
            level: BusinessLevels.MEDIUM_BUSINESS_ENTERPRISE,
            employees: "20-100",
            price: "$15,000.00",
            description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
        },
        {
            isActive: false,
            level: BusinessLevels.ASSOCIATED_COMPANY,
            employees: "100+",
            price: "$15,000.00",
            description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
        },
    ])

    const [paymentOptions, setPaymentOption] = useState<Array<{ isActive: boolean, name: string, icon: any, component: any }>>([
        {
            isActive: true,
            name: "Lynk",
            icon: LYNK_ICON,
            component: <LynkComponent/>
        }
    ])

    useEffect(() => {
        setMembershipLevel((prevLevels) => prevLevels.map((prevLevel) =>
            prevLevel.level === newBusinessInfo?.category.number_of_employees ?
                {...prevLevel, isActive: true} : {...prevLevel, isActive: false}))
    }, [newBusinessInfo?.category.number_of_employees])

    useEffect(() => {
        setSectionName('Payment')
    }, [setSectionName]);


    const [initialValues] = useState({
        payment: newBusinessInfo?.payment
    });

    const changePaymentOption = (selectedName: string) => {
        setPaymentOption((prevOptions) => (prevOptions.map((prevOption) => prevOption.name === selectedName ? {
            ...prevOption,
            isActive: true
        } : {...prevOption, isActive: false})))
    }

    const onSubmit = async (values: any, {setSubmitting}: any) => {
        setNewBusinessInfo && setNewBusinessInfo((prevInfo) => ({...prevInfo, payment: values.payment}))
        submitForm && submitForm();
        setSubmitting(false);
    }
    return (
        <div className={'add-business-section payment'}>

            <p className={'info'}><span>Note:</span> Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. </p>

            <div className="payment_membership">
                <span>Membership Level</span>
                {
                    memberShipLevel.filter((level) => level.isActive).map(({
                                                                               level,
                                                                               employees,
                                                                               price,
                                                                               description
                                                                           }, index) => (
                        <div key={index + level} className="payment_membership_level">
                            <span>{level}</span>
                            <p className={'payment_membership_level_desc'}>{description}</p>

                            <div className={'grid-2'}>
                                <span>No. Employees:</span>
                                <span>{employees}</span>
                            </div>
                            <div className={'grid-2'}>
                                <span>Cost</span>
                                <p>{price}</p>

                            </div>
                        </div>

                    ))
                }
            </div>
            <Formik
                validateOnMount={false}
                validateOnChange={true}
                initialValues={initialValues}
                // validationSchema={BusinessFormCategoryValidation}
                onSubmit={onSubmit}
            >
                {/*{({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (*/}
                {({handleSubmit}) => (
                    <form onSubmit={handleSubmit}>
                        <span>Payment Options:</span>
                        <div className={'payment_options'}>
                            {paymentOptions.map(({icon, isActive, name}, index) => (
                                <div key={'payment-o' + name + index}
                                     className={['payment_options_option', isActive && 'active'].join(' ')}
                                     onClick={() => changePaymentOption(name)}>
                                    {<img src={icon} alt=""/>}
                                </div>
                            ))}
                        </div>

                        <div className="payment_options_component">
                            {
                                paymentOptions.filter((prevOption) =>
                                    prevOption.isActive).map(({
                                                                  isActive,
                                                                  component
                                                              }, index) =>
                                    (isActive && <div key={'payment-comp' + index}>{component}</div>))
                            }
                        </div>
                        <div className={'add-business-section_cta'}>
                            <Button type={"secondary"} onclick={() => changeStep && changeStep("prev")} text={"Prev"}/>
                            <Button type={"primary"} isSubmit={true} text={"Submit Request"}/>
                        </div>
                    </form>
                )}
            </Formik>
        </div>

    );
};

export default Payment;


const LynkComponent = () => {

    return (
        <div className={'lynk'}>
            <p className={'instruction'}>
                <strong>Instruction: </strong> Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
            </p>

            <div className={'lynk_qr-code'}>
                <img src={LYNK_QR_IMAGE} alt=""/>
            </div>
        </div>
    );
}

